<template>
  <div>
    <div
      v-if="stage.title && $can('set', 'useCommonAgreements')"
      class="state-name">
      {{ stage.title }}
    </div>
    <PersonWithStatus
      v-for="(acceptor, n) in stage.agreements"
      :key="n"
      class="pb-3 px-0"
      :data-qa="`${dataQa}-person-with-status`"
      show_additional
      :status="acceptor.status"
      :status-name="acceptor.statusTitle"
      :tender-id="stage.tenderId"
      :user="acceptor"
      with_photo
      without_tooltip
      @click-info="val => $emit('click-info', val)"/>
  </div>
</template>
<script>
import PersonWithStatus from 'components/common/blocks/PersonWithStatus.vue'

/**
 * Согласованты в разерзе конкретной стадии
 */
export default {
  name: 'StageAgreement',
  components: {
    PersonWithStatus
  },
  props: {
    stage: {
      type: Object
    },
    dataQa: {
      type: String,
      default: 'stage-agreement'
    },
  },
}
</script>
<style scoped lang="scss">
.state-name {
  display: block;
  text-align: left;
  color: var(--black-color);
  background: var(--v-secondary__green_chosen-base);
  border-radius: 8px;
  padding: 5px 20px;
  margin-bottom: 12px;
}
</style>
